import { environment } from './../../../environments/environment';
import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'imgValidator'
})
export class ImgValidatorPipe implements PipeTransform {

  baseUrl = environment.serverUrl;

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  transform(value: any, entity: Entity = Entity.User):  any {
    let Url = `${this.baseUrl}/${value}`;

    return this.http
            .get(Url, { responseType: 'blob' })
            .pipe(map(val => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))));

  }
}

export enum Entity {
  User,
}
